import InsightsSection from "../components/insights/Insights";
import FeaturedArticle from "../components/insights/FeaturedArticle";

const Insights = () => {
  return (
    <div className="page-container">
      <FeaturedArticle />
      <InsightsSection />
    </div>
  );
};

export default Insights;